import React from 'react';
import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}


const MailContactList: React.FC = () => {
  const endpoint = '/mail-contact';
  const title = 'Contatos no website';

  const { projectHash, eventHash } = useParams<Record<string, any>>(); const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },
    project_id: { ref: 'project_id', column: 'project_id', label: 'Projeto' },
    form_id: {
      ref: 'form_id',
      column: 'form_id_response',
      includeColumn: 'title',
      label: 'Formulário',
    },

    name: { ref: 'name', column: 'name', label: 'Nome' },
    phone: { ref: 'phone', column: 'phone', label: 'Telefone' },
    email: { ref: 'email', column: 'email', label: 'E-mail' },
    message: { ref: 'message', column: 'message', label: 'Mensagem' },
    send_to: { ref: 'send_to', column: 'send_to', label: 'Enviado para' },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {
    form_id: {
      alias: 'form_id',
      model: 'selectApi',
      name: 'form_id',
      label: 'Formulário',
      endpoint,
    },
    phone: { model: 'input', type: 'text', name: 'phone', label: 'Telefone' },
    name: { model: 'input', type: 'text', name: 'name', label: 'Nome' },
    email: { model: 'input', type: 'text', name: 'email', label: 'E-mail' },

    message: { model: 'input', type: 'text', name: 'message', label: 'Mensagem' },


  };

  const formSchemaUpdate = {


    ...formSchema



  };

  const formValidation: Record<string, ValidationSchema> = {

  };

  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default MailContactList;
